var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4.222 8.316V5.158h2.222c0 .582.497 1.053 1.112 1.053.614 0 1.11-.471 1.11-1.053h6.667c0 .582.497 1.053 1.111 1.053.615 0 1.112-.471 1.112-1.053h2.222v3.158zm0 11.579h15.556V10.42H4.222zM17.556 3.053c0-.582-.497-1.053-1.112-1.053-.614 0-1.11.47-1.11 1.053H8.666C8.667 2.47 8.17 2 7.556 2c-.615 0-1.112.47-1.112 1.053H4.222C2.996 3.053 2 3.996 2 5.158v14.737C2 21.057 2.996 22 4.222 22h15.556C21.004 22 22 21.057 22 19.895V5.158c0-1.162-.996-2.105-2.222-2.105z"
})));
export default SvgGemCalendar;